// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"9e0e5e1b","236":"8e32a202"}[chunkId] + ".chunk.css";
};